// extracted by mini-css-extract-plugin
export default {"main":"SearchClient_main__n8PBw","formGroup":"SearchClient_formGroup__AZvbc","searchBox":"SearchClient_searchBox__wtysL","searchBtn":"SearchClient_searchBtn__6v0EU"};